module.exports = __webpack_public_path__ + "img/vps8.20d527a.png";